import * as React from 'react';

function ArrowsExpandIcon (props) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
            <path
                d="M3.33203 6.66732V3.33398M3.33203 3.33398H6.66536M3.33203 3.33398L7.4987 7.50065M16.6654 6.66732V3.33398M16.6654 3.33398H13.332M16.6654 3.33398L12.4987 7.50065M3.33203 13.334V16.6673M3.33203 16.6673H6.66536M3.33203 16.6673L7.4987 12.5007M16.6654 16.6673L12.4987 12.5007M16.6654 16.6673V13.334M16.6654 16.6673H13.332"
                stroke="#272560"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default ArrowsExpandIcon;
